var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.506 3.15451L4.34855 9.67201C4.11605 9.91951 3.89105 10.407 3.84605 10.7445L3.56855 13.1745C3.47105 14.052 4.10105 14.652 4.97105 14.502L7.38605 14.0895C7.72355 14.0295 8.19605 13.782 8.42855 13.527L14.586 7.00951C15.651 5.88451 16.131 4.60201 14.4735 3.03451C12.8235 1.48201 11.571 2.02951 10.506 3.15451Z",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 4.24121C9.80297 6.31121 11.483 7.89371 13.568 8.10371",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 16.9541H16.3125",
    stroke: "#64748B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.b6c92170c404f57fa5f1887502eb2c9b.svg";
export { ForwardRef as ReactComponent };